import * as State from "./StateSaver";

export * from "./Types";
export const Configs = { state: State.Config };
export const Icons = { [State.Config.iconKey]: State.Icon };